import { Clickable } from '@carvana/merch-components';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { initialRecommendedVehicles } from '~/constants/initialRecommendedVehicles';
import { RecommendedVehicle } from '~/contracts/vdp';
import { useMakeModelSearchLink } from '~/hooks/vdp';
import DownArrow from '~/icons/DownArrow';
import { getIsLite } from '~/selectors';
import {
  FlexWrapper,
  ViewAllButton,
  ViewMoreButton
} from '../CarCompare.styles';
import { totalVehiclesGrid } from '../constants';
import VehicleTile from '../VehicleTile';

type OwnProps = {
  showLoadMore?: boolean;
  vehicles: RecommendedVehicle[];
};

const ViewAllLink = ({ showBreadcrumbTreatment }) => {
  const viewMoreCarsLink = useMakeModelSearchLink();
  const shouldShowViewMoreCars = useSelector(getIsLite);
  const viewAllCopy = showBreadcrumbTreatment
    ? 'Browse All Vehicles'
    : 'View All';

  return shouldShowViewMoreCars ? (
    <a
      href={viewMoreCarsLink}
      data-analytics-id={`Vehicles You Might Like - ${viewAllCopy}`}
    >
      <ViewAllButton>{viewAllCopy}</ViewAllButton>
    </a>
  ) : null;
};

const ShowMoreButtons = ({
  showViewMore,
  viewMoreOnClick,
  showBreadcrumbTreatment
}) => {
  const viewMoreCopy = showBreadcrumbTreatment
    ? 'See More Recommended'
    : 'View More';

  return showViewMore ? (
    <Clickable
      element={ViewMoreButton}
      data-analytics-id={`Vehicles You Might Like - ${viewMoreCopy}`}
      onClick={viewMoreOnClick}
    >
      {viewMoreCopy}
      <DownArrow className="fill-current" />
    </Clickable>
  ) : (
    <ViewAllLink showBreadcrumbTreatment={showBreadcrumbTreatment} />
  );
};

const CarCompareGrid = ({ vehicles, showLoadMore = true }: OwnProps) => {
  const [amountToRender, setAmountToRender] = useState(
    initialRecommendedVehicles
  );
  const isLite = useSelector(getIsLite);
  const showViewMore =
    amountToRender < totalVehiclesGrid && vehicles.length > amountToRender;

  return (
    <div className="flex flex-col items-center">
      <FlexWrapper>
        {vehicles.slice(0, amountToRender).map(vehicle => (
          <VehicleTile key={vehicle.vehicleId} vehicle={vehicle} />
        ))}
      </FlexWrapper>
      {showLoadMore && (
        <ShowMoreButtons
          viewMoreOnClick={() => setAmountToRender(vehicles.length)}
          showViewMore={showViewMore}
          showBreadcrumbTreatment={isLite}
        />
      )}
    </div>
  );
};

export default CarCompareGrid;
